import { QuestionnaireStatus } from '@/components/decision-tree';
import useIsMobile from '@/hooks/use-is-mobile';
import { Divider, Flex } from '@cmpsr/components';
import React from 'react';
import PaymentMethod, { PaymentMethodProps } from '../payment-method/payment-method';
import CommPreferences, { CommPreferencesProps } from './components/comm-preferences/comm-preferences';
import Membership, { MembershipProps } from './components/membership/membership';
import PersonalInfo, { PersonalInfoProps } from './components/personal-info/personal-info';
import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';

type AccountTabProps = PersonalInfoProps &
  MembershipProps &
  CommPreferencesProps &
  PaymentMethodProps & {
    assessmentProgress: number;
    questionnaireStatus: QuestionnaireStatus;
    iDontKnowAnswers: number;
    totalAnsweredQuestions: number;
    isVipAccess: boolean;
  };

function AccountTab({
  name,
  email,
  cardLast4Digits,
  type,
  usdPrice,
  renewalDate,
  cancelAtPeriodEnd,
  notificationsPreferences,
  paymentFunding,
  isVipAccess,
  subscriptionStatus,
}: AccountTabProps) {
  const isMobile = useIsMobile();

  return (
    <DashboardGrid
      pt={{ base: 5, md: 8, lg: 12 }}
      gap={{ base: 4, lg: 8, xl: 9, xxl: 12 }}
      gridTemplateAreas={{
        base: `"aside"
                "main"`,
        lg: `"main aside"`,
      }}
    >
      <Flex direction="column" flex="1" width="100%" gap={{ base: 'spacer-4', lg: 'spacer-6' }} gridArea="main">
        <PersonalInfo name={name} email={email} />
        {!isVipAccess && <PaymentMethod cardLast4Digits={cardLast4Digits} paymentFunding={paymentFunding} />}
        <CommPreferences notificationsPreferences={notificationsPreferences} />
      </Flex>
      <Flex direction="column" gap="spacer-4" gridArea="aside">
        {isMobile && <Divider />}
        <Membership
          usdPrice={usdPrice}
          renewalDate={renewalDate}
          type={type}
          cancelAtPeriodEnd={cancelAtPeriodEnd}
          subscriptionStatus={subscriptionStatus}
        />
      </Flex>
    </DashboardGrid>
  );
}

export default React.memo(AccountTab);
